import {
  BE_CALL_ALERTING,
  BE_CALL_ANSWERED,
  BE_HOLD_CALL,
  BE_END_CALL,
  BE_RETRIEVE_CALL,
} from '@rsos/constants/callStatuses';

/**
 * Get call status theme colors based on call status value from backend.
 * @returns String
 */
const getCallStatusColor = (status: string, isBGColor?: boolean) => {
  switch (status) {
    case BE_CALL_ALERTING:
      return `tag.warning.${isBGColor ? 'bg' : 'text'}`;
    case BE_CALL_ANSWERED:
      return `tag.success.${isBGColor ? 'bg' : 'text'}`;
    case BE_HOLD_CALL:
      return `tag.caution.${isBGColor ? 'bg' : 'text'}`;
    case BE_END_CALL:
      return `tag.secondary.${isBGColor ? 'bg' : 'text'}`;
    case BE_RETRIEVE_CALL:
      return `tag.success.${isBGColor ? 'bg' : 'text'}`;
    default:
      return `tag.secondary.${isBGColor ? 'bg' : 'text'}`;
  }
};

export default getCallStatusColor;
